export interface ImLoginCredentials {
  SDKAppID: number;
  userID: string;
  userSig: string;
}

let cached: ImLoginCredentials | null = null;

/** For non-React code (e.g. telemetry) that needs the last successful IM login. */
export function cacheImLoginCredentials(c: ImLoginCredentials): void {
  cached = c;
}

export function getCachedImLoginCredentials(): ImLoginCredentials | null {
  return cached;
}
